import {
  MemCommonEditor,
  MemCommonEditorInstance,
  MemCommonEditorTheme,
} from "@mem-labs/common-editor";
import { FC, useRef, useMemo } from "react";
import {
  createReadonlyArtifactEditorConfig,
  NoteInfo,
} from "./session-artifact-note-renderer.utils";
import styled from "@emotion/styled";
import { motion } from "motion/react";
import { useTheme } from "@/mds/themes";

export type SessionArtifactNoteRenderingData = {
  noteInfo: NoteInfo;
  previousNoteInfo?: NoteInfo;
  showDifferences?: boolean;
};

export type SessionArtifactNoteRendererProps = {
  data: SessionArtifactNoteRenderingData;
};

export const SessionArtifactNoteRenderer: FC<SessionArtifactNoteRendererProps> = ({ data }) => {
  const { noteInfo, previousNoteInfo, showDifferences } = data;
  const editorInstanceRef = useRef<MemCommonEditorInstance | null>(null);
  const { themeType } = useTheme();

  const theme =
    themeType === "harvest" ? MemCommonEditorTheme.Harvest : MemCommonEditorTheme.HarvestMoon;

  const editorConfig = useMemo(
    () =>
      createReadonlyArtifactEditorConfig({
        noteInfo,
        previousNoteInfo,
        showDifferences,
        theme,
      }),
    [noteInfo, previousNoteInfo, showDifferences, theme]
  );

  return (
    <Container
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: {
          duration: 0.1,
          delay: showDifferences ? 0.4 : 0.2,
        },
      }}
    >
      <MemCommonEditor
        editorInstanceRef={editorInstanceRef}
        editorInitializer={editorConfig.editorInitializer}
        editorEventHandler={editorConfig.editorEventHandler}
      />
    </Container>
  );
};

const Container = styled(motion.div)`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  overscroll-behavior-y: contain;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  .tiptap {
    padding: 16px;
  }
`;
